<template>
  <div id="sugr_btn" @mouseup="emitClick($event)">
    <div :class="['btn',this.sugrType]">
      <span>
        <slot></slot>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "sugr-btn",
  props: {
    sugrType: {
      type: String,
      default: () => {
        return "big";
      }
    }
  },
  methods: {
    emitClick() {
      //   console.log($event);
      this.$emit("click");
    }
  }
};
</script>
<style lang="scss" scoped>
#sugr_btn {
  height: 100%;
  min-height: 40px;
  max-height: 58px;
  box-sizing: border-box;
  width: 100%;
  // border: 1px solid red;
  display: flex;
  justify-content: center;
  align-items: center;
  .btn {
    font-size: 1rem;
    // border: 1px solid blue;
    margin: 0 auto;
    color: #fff;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .newPage {
    height: 50px;
    width: 265px;
    padding-bottom: 4px;
    background: url("../assets/invitation/newPageBtn.png") 50% 0% no-repeat;
    background-size: 100% 100%;
  }

  .big {
    height: 80%;
    width: 80%;
    padding-bottom: 4px;
    background: url("../assets/invitation/btn_a.png") 50% 0% no-repeat;
    background-size: 100% 100%;
  }

  .left {
    height: 72%;
    max-height: 38px;
    padding-bottom: 4px;
    background: url("../assets/invitation/small_left_a.png") 50% 0% no-repeat;
    background-size: 100% 100%;
  }

  .right {
    height: 72%;
    max-height: 38px;
    padding-bottom: 4px;
    background: url("../assets/invitation/small_right_a.png") 50% 0% no-repeat;
    background-size: 100% 100%;
  }

  &:active {
    .big {
      margin-top: 2px;
      background: url("../assets/invitation/btn_b.png") 50% 0% no-repeat;
      background-size: 100% 100%;
    }

    .left {
      margin-top: 2px;
      background: url("../assets/invitation/small_left_b.png") 50% 0% no-repeat;
      background-size: 100% 100%;
    }

    .right {
      margin-top: 2px;
      background: url("../assets/invitation/small_right_b.png") 50% 0% no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>